const tj = {
  online_airport_board: "Таблои онлайнӣ фурудгоҳ",
  scoreboard: "Табло",
  services: "Хизматрасониҳо",
  location_map: "Ҷойгиршавии мо дар харита",
  location: "Ҷойгиршавии мо дар харита",
  location_text: "А-105, километри 40-ум, 3, округи шаҳрии Домодедово, вилояти Москва, 142034",
  contact_address: "142046, вилояти Москва, шаҳри Домодедово, 40 км шоҳроҳи А-105, бино 3, хона №88",
  address: "Суроға",
  agreement_text:
    "Бо ворид шудан ба сайт, шумо бо Сиёсати махфият ва қоидаҳои ҷамъоварӣ ва коркарди маълумоти шахсӣ розӣ мешавед",
  login_title_text: "Воридшавӣ ба ҳисоби шахсӣ",
  login_text: "Логин",
  password_text: "Парол",
  forgot_password_text: "Паролро фаромӯш кардед?",
  reset_password_text: "Барқарор кардани парол",
  registration_text: "Бақайдгирӣ",
  new_customer: "Истифодабарандаи нав?",
  logged_user_text: "Аллакай ҳисоб доред?",
  enter_text: "Ворид шудан",
  invalid_password: "Камаш 6 аломат",
  invalid_email: "Email нодуруст аст",
  required: "Майдони ҳатмӣ",
  travel_time: "Вақти сафар",
  flight: "Парвоз",
  flights: "Самтҳо",
  terminal: "Терминал",
  baggage: "Бор",
  hand_luggage: "Борчаи дастӣ",
  refund_ticket: "Баргардонидани билет",
  change: "Иваз кардани билет",
  no_refund: "Барасмиятдарорӣ надорад",
  yes_refund: "Барасмиятдарорӣ дорад",
  no_change: "Иваз карда намешавад",
  yes_change: "Имкони иваз кардан вуҷуд дорад",
  yes_baggage: "Бо бор",
  no_baggage: "Бе бор",
  yes_hand_luggage: "Бо борчаи дастӣ",
  no_hand_luggage: "Бе борчаи дастӣ",
  show_rules: "Нишон додани қоидаҳо",
  total: "Ҳамагӣ",
  passengers: "Сафарбарон",
  select_from_list: "Аз рӯйхат интихоб кунед",
  name_as_in_document: "Ном тибқи ҳуҷҷат",
  middlename_as_in_document: "Номи падар тибқи ҳуҷҷат",
  surname_as_in_document: "Насаб тибқи ҳуҷҷат",
  date_of_birth: "Санаи таваллуд",
  gender: "Ҷинс",
  citizenship: "Шаҳрвандӣ",
  age: "Синну сол",
  document: "Ҳуҷҷат",
  payer: "Пардохткунанда",
  for_payer_mess: "Ба почтаи шумо маълумоти бронкуниро мефиристем. Телефон барои огоҳкуниҳои фаврӣ лозим аст",
  series_and_number: "Серия ва рақам",
  valid_until: "Муҳлат то",
  airline_bonus_card: "Корти бонусии ширкати ҳавопаймоӣ",
  number_bonus_card: "Рақами корти бонусӣ",
  phone_number: "Рақами телефон",
  contact_number: "+998 97 985 00 06 (ҳар рӯз аз 9:00 то 23:00)",
  email: "Email",
  workH: "Вақти корӣ",
  working_hours: "рӯзҳои корӣ аз 10:00 то 17:00",
  how_to_read_rules: "Чӣ гуна қоидаҳоро хондан",
  tariff_rules: "Қоидаҳои тариф",
  book_and_proceed_to_payment: "Брон кунед ва ба пардохт гузаред",
  agreement_book_text: 'Бо пахш кардани "Брон кардан ва гузаштан ба пардохт" шумо розигии худро бо',
  agreement_book_link: "шартҳои тарифии ширкат",
  everywhere_local_time: "Дар ҳама ҷо вақти маҳаллии парвоз ва фуруд омадан нишон дода мешавад",
  duration: "давомнокӣ",
  in: "дар",
  no_data_contact_technical_support: "Маълумот нест. Ба дастгирии техникӣ муроҷиат кунед.",
  back_to_orders: "Ба фармоишҳо баргаштан",
  incorrect_date_from_adt: "Сана барои калонсол нодуруст аст",
  incorrect_date_from_chd: "Сана барои кӯдак нодуруст аст",
  incorrect_date_from_inf: "Сана барои ширхӯр нодуруст аст",
  incorrect_date: "Сана нодуруст аст",
  check_date_and_change_doc: "Санаро санҷед ё намуди ҳуҷҷатро иваз кунед",
  warning_inf_date: "Ширкати ҳавопаймоӣ метавонад барои навзод ҳуҷҷати иҷозати парвозро талаб кунад",
  ps_should_be_10_digits: "Дар шиносномаи РФ бояд 10 рақам бошад",
  psp_should_be_9_digits: "Дар шиносномаи хориҷии РФ бояд 9 рақам бошад",
  incorrect_doc_number: "Рақами ҳуҷҷат нодуруст аст",
  hint_for_ps_doc: "Серия ва рақами шиносномаро ворид кунед, масалан 1234567890",
  hint_for_psp_doc: "Рақами шиносномаро ворид кунед, масалан 123456789",
  hint_for_sr_doc: "Рақами шаҳодатномаи таваллуд, масалан IXЯЯ123456",
  hint_for_np_doc: "Серия ва рақами ҳуҷҷатро ворид кунед",
  male: "Мард",
  female: "Зан",
  russian_passport: "Шиносномаи РФ",
  birth_certificate: "Гувоҳномаи таваллуд (РФ)",
  international_passport: "Шиносномаи хориҷии РФ",
  foreign_document: "Ҳуҷҷати хориҷӣ",
  national_passport_id_card: "Шиносномаи миллӣ (ID корт)",
  domestic_birth_certificate: "Шаҳодатномаи таваллуд",
  place_one: "ҷой",
  place_more: "ҷой",
  place_many: "ҷой",
  customer_support: "Дастгирии муштариён",
  financial_matters: "Масъалаҳои молиявӣ",
  agreement_footer_text: "Истифодаи маводҳо бидуни иҷозати хаттӣ манъ аст",
  flight_schedule: "Ҷадвали парвозҳо",
  offer: "Оферта",
  question_answer: "Савол — Ҷавоб",
  jobs: "Вакансияҳо",
  facebook: "Facebook",
  about_us: "Дар бораи мо",
  currency: "Асъор",
  language: "Забон",
  search: "Ҷустуҷӯ",
  personal_info: "Маълумоти шахсӣ",
  personal_area: "Ҳисоби шахсӣ",
  not_found_page: "Саҳифае, ки ҷустуҷӯ мекардед, ёфт нашуд",
  to_main: "Ба саҳифаи асосӣ",
  log_out: "Баромадан",
  session: "Сессия",
  error_500_text:
    "Чизе нодуруст шуд, вале мо дар бораи мушкил огоҳем ва ислоҳи онро оғоз кардем. Аз нороҳатиҳо узр мепурсем.",
  lang_ru: "Русӣ",
  lang_tj: "Тоҷикӣ",
  lang_en: "Англисӣ",
  balance: "Баланс",
  otb: "Баланс",
  own_funds: "Воситаҳои шахсӣ",
  credit_balance: "Баланс бо қарз",
  credit_line: "Хатти қарзӣ",
  no: "Не",
  for_route: "Барои самт",
  to_result_search: "Ба натиҷаҳои ҷустуҷӯ",
  only_a_z_space: "Танҳо ҳарфҳои лотинӣ ва фосила",
  only_a_z: "Танҳо ҳарфҳои лотинӣ",
  invalid_phone: "Рақами телефон нодуруст аст",
  min_2_symbol: "Камаш 2 аломат",
  select_value_from_list: "Аз рӯйхат интихоб кунед",
  check_date: "Санаро санҷед",
  incorrect_number: "Рақам нодуруст аст",
  incorrect_cvc: "Коди CVC нодуруст аст",
  incorrect_card_holder: "Номи дорандаи корт нодуруст аст",
  incorrect_card_month: "Моҳи нодуруст",
  incorrect_card_year: "Соли нодуруст",
  code: "Код",
  message: "Паём",
  close: "Пӯшидан",
  error_message_part_1: "Чизе нодуруст шуд. Лутфан, барои муайян кардани мушкил ба дастгирии техникӣ муроҷиат кунед",
  error_message_part_2: "ва рақами сессияро хабар диҳед",
  error_message_part_3: "Пас аз пӯшидани паём шумо ба саҳифаи асосӣ равон карда мешавед.",
  choose: "Интихоб",
  collapse: "Печондан",
  looking_tickets: "Билетҳоро ҷустуҷӯ дорем",
  wait_please: "Лутфан интизор шавед",
  we_issue_tickets: "Мо билетҳоро мебарорем, ин вақти зиёд намегирад",
  created: "Эҷод шуд",
  left: "Мондааст",
  less_than_minute: "камтар аз як дақиқа",
  help: "Кумак",
  exchange_and_return_rules: "Қоидаҳои иваз ва баргардонидан",
  after_flight: "Пас аз парвоз",
  go_to_section: "Гузаштан ба бахш",
  next: "Баъдӣ",
  earlier: "Пештар",
  not_book_tickets: "Шумо билетҳои броншуда надоред",
  route_from: "Аз",
  route_to: "Ба",
  date_from: "Туда",
  date_to: "Баргашт",
  find: "Ёфтан",
  add_route: "Иловаи парвоз",
  one_way: "Як тараф",
  two_way: "Туда ва баргашт",
  multi_way: "Маршрути мураккаб",
  economy: "Иқтисодӣ",
  business: "Бизнес",
  first: "Аввалин",
  all_class: "Ҳамаи синфҳо",
  adt_main_label: "Калонсол",
  inf_main_label: "Ширхӯр",
  chd_main_label: "Кӯдак",
  adt_second_label: "аз 12 сол боло",
  chd_second_label: "2 — 12 сол",
  inf_second_label: "то 2 сол (бе ҷой)",
  inf_with_seat_second_label: "бо ҷой",
  passenger_1: "Як мусофир",
  passenger_2: "Ду мусофир",
  passenger_3: "Се мусофир",
  passenger_4: "Чор мусофир",
  passenger_5: "Панҷ мусофир",
  passenger_6: "Шаш мусофир",
  agents: "Агентҳо",
  passenger_7: "Ҳaft мусофир",
  passenger_8: "Ҳашт мусофир",
  passenger_9: "Нуҳ мусофир",
  only_there: "Ба як тараф",
  roundtrip: "Туда-баргашт",
  your_profile: "Профили шумо",
  client_name: "Номи муштарӣ",
  client_code: "Коди муштарӣ",
  partner_code: "Коди шарик",
  partner_name: "Номи шарик",
  partner_currency: "Асъори шарик",
  current_balance: "Баланс дар ҳоли ҳозир",
  debt: "Қарздорӣ",
  credit_limit: "Маҳдудияти қарзӣ",
  deposit: "Депозит",
  change_password: "Иваз кардани парол",
  old_password: "Пароли ҷорӣ",
  new_password: "Пароли нав",
  confirmation_password: "Тасдиқи парол",
  save: "Сабт кардан",
  passwords_must_match: "Паролҳо бояд мувофиқат кунанд",
  password_changed_successfully: "Парол бо муваффақият иваз шуд",
  departure_title: "Парвоз",
  there_title: "Туда",
  back_title: "Баргашт",
  validates_flights: "парвозҳоро тасдиқ мекунад",
  pay_for_your_reservation: "барои пардохти брон",
  hour_short: "соат",
  day_short: "рўз",
  minutes_short: "дақ",
  minutes_short_3: "дақиқа",
  on_way: "Дар роҳ",
  no_transfers: "Бе гузариш",
  class: "Синф",
  tariff_options: "Имконоти тариф",
  with_luggage: "Бо бор",
  without_luggage: "Бе бор",
  quick_picks_title: "Интихоби зуд",
  quick_optimal: "Оптималӣ",
  quick_cheapest: "Арзонтарин",
  quick_fastest: "Тезтарин",
  quick_transfers: "{{count}} гузариш",
  quick_pick_hint: "Дар рӯйхат нишон додан",
  hours_short: "с",
  airline_combination: "Омезиши ширкатҳои ҳавопаймоӣ",
  with_airline_combination: "Омезишҳо",
  without_airline_combination: "Як чипта",
  vtrip_notice: "Ин парвоз бо чиптаҳои алоҳида расмӣ карда мешавад. Баргардонидан ва ивазкунии онҳо мустақилона мегузарад. Агар аз рӯи як чипта ҷадвал тағйир ёбад ё парвоз бекор шавад, баргардонидан ва ивазкунии чиптаи дуюм ихтиёрӣ, мувофиқи қоидаҳои тариф иҷро мешавад.",
  no_timelimit: "Маълумот дар бораи вақти пардохт нест",
  legal_information: "Маълумоти ҳуқуқӣ",
  opportunities: "Имкониятҳо",
  same_routes: "Самтҳои монанд",
  tajikistan_attractions: "Ҷойҳои диданбоби Тоҷикистон",
  routes: "Самтҳо",
  rules_of_use: "Қоидаҳои истифода",
  privacy_policy: "Сиёсати махфият",
  payment: "Пардохт",
  provider: "Поставщик",
  price: "Нарх",
  detail: "Тафсилот",
  label_price_by_min: "Нарх (аз кам ба зиёд)",
  label_price_by_max: "Нарх (аз зиёд ба кам)",
  transfers: "Гузаришҳо",
  all_flights: "Ҳамаи парвозҳо",
  without_transfers: "Бе гузариш",
  one_transfer: "1 гузариш",
  many_transfer: "2 гузариш ва бештар",
  not_found_recomm_first_text: "Мутаассифона, мувофиқи дархости шумо билет ёфт нашуд",
  not_found_recomm_second_text: "Лутфан, сана ё фурудгоҳро иваз карда боз кӯшиш кунед",
  not_found_recomm_by_filters: "Лутфан, танзими филтрҳоро тағйир диҳед",
  flight_details: "Тафсилоти парвоз",
  change_tariff: "Иваз кардани тариф",
  tariffs: "Тарифҳо",
  teh_stop: "Истгоҳи техникӣ",
  transfer: "Гузариш",
  local_time_message: "Вақти парвоз ва фуруд маҳаллӣ аст",
  route_tariffs_message: "Тариф ба тамоми маршрут дахл дорад",
  airlines: "Ширкатҳои ҳавопаймоӣ",
  airports: "Фурудгоҳҳо",
  departure: "Парвоз",
  arrival: "Фуруд омадан",
  departure_time: "Вақти парвоз",
  arrival_time: "Вақти фуруд",
  flight_number: "Рақами парвоз",
  multiple_numbers_separated_by_spaces: "Якчанд рақам тавассути фосила",
  lowcost: "Lowcost",
  transfer_1: "гузариш",
  transfer_2_4: "гузариш",
  transfer_5: "гузариш",
  free_seats_0: "ҷой нест",
  free_seats_1: "ҷой",
  free_seats_2_4: "ҷой",
  free_seats_5: "ҷой",
  one_adt: "Калонсол",
  more_adt: "Калонсол",
  many_adt: "Калонсолон",
  one_chd: "Кӯдак",
  more_chd: "Кӯдакон",
  many_chd: "Кӯдакон",
  one_inf: "Ширхӯр",
  more_inf: "Ширхӯр",
  many_inf: "Ширхӯрон",
  flight_one: "парвоз",
  flights_more: "парвоз",
  flights_many: "парвоз",
  found_one: "Ёфт шуд",
  found_more: "Ёфт шуд",
  flight_overview: "Шарҳи умумии парвоз",
  to_top: "Ба боло",
  book: "Брон кардан",
  buyer: "Харидор",
  pnr: "Коди брон / PNR",
  online_registration_locator: "Локатор барои бақайдгирии онлайн",
  route_information: "Маълумот дар бораи маршрут",
  order: "Фармоиш",
  flights_tickets: "Билетҳои ҳавоӣ",
  void_text: "Шумо метавонед ҳар вақт фармоишро бекор кунед",
  void_order: "Бекор кардани фармоиш",
  support_chat: "Чати дастгирӣ",
  payment_method: "Усули пардохт",
  payment_with_balance: "Пардохт аз баланс",
  payment_with_card: "Пардохт бо корт",
  info_account: "Ҳисоби иттилоотӣ",
  get_tickets: "Билетҳоро бароред",
  left_before_the_time_limit: "Мондааст то анҷоми вақт",
  expires: "Анҷом меёбад",
  payment_timed_out: "Вақти пардохт анҷом ёфт",
  cashback_label: "Кэшбэк",
  cashback_accrued_label: "Кэшбэк гузаронида шуд",
  cashback_hint: "Кэшбэк пас аз парвоз ба тавозуни кабинети шахсӣ гузаронида мешавад (танҳо барои корбарони бақайдгирифта)",
  time_expired: "Вақт гузашт",
  order_created: "Фармоиш эҷод шуд",
  return_ticket: "Баргардонидани билет",
  exchange_ticket: "Иваз кардани билет",
  download_itinerary_receipt: "Қабули роҳхатро бор кунед",
  order_cost: "Арзиши фармоиш",
  invoice_for_payment: "Ҳисобнома барои пардохт",
  void_in_process: "Фармоиш дар ҳолати бекоркунӣ",
  initial: "Фармоиш эҷод шуд",
  in_progress: "Билет брон шудааст",
  success: "Пардохти муваффақ, билетҳо бароварда шуданд",
  partially_success: "Фармоиши қисман муваффақ",
  booking_fail: "Хатогӣ ҳангоми бронкунӣ",
  order_fail: "Хатогӣ ҳангоми эҷоди фармоиш",
  pay_fail: "Хатогӣ ҳангоми пардохт",
  order_cancel_from_client: "Фармоиш аз ҷониби муштарӣ бекор шуд",
  order_cancel_from_admin: "Фармоиш аз ҷониби администратор бекор шуд",
  order_cancel_by_job: "Фармоиш мувофиқи таймлимит бекор шуд",
  order_cancel_error: "Хатогӣ ҳангоми бекоркунӣ",
  application_refund: "Ариза барои баргардонидани маблағ эҷод шуд",
  partial_refund: "Бозгашти қисман анҷом шуд",
  order_cancel_by_gds: "Фармоиш мувофиқи таймлимит бекор шуд",
  refund: "Баргардонидан",
  ticketing_done: "Пардохти муваффақ, билетҳо бароварда шуданд",
  pay_success: "Пардохти муваффақ, билетҳо дар раванди барориш",
  booking_done: "Билет брон шуд",
  exchange: "Иваз",
  void: "Бекор",
  ticketing_fail: "Хатогӣ ҳангоми барориши билетҳо",
  year_one: "сол",
  year_more: "сол",
  years: "сол",
  day_one: "рӯз",
  day_more: "рӯз",
  days: "рӯз",
  hour_one: "соат",
  hour_more: "соат",
  hours: "соат",
  minute_one: "дақиқа",
  minute_more: "дақиқа",
  minutes: "дақиқа",
  second_one: "сония",
  second_more: "сония",
  seconds: "сония",
  passenger_list: "Рӯйхати мусофирон",
  your_name: "Номи шумо",
  search_order: "Ҷустуҷӯи фармоиш",
  locator: "Локатор",
  cancel: "Бекор кардан",
  passenger_name: "Насаби мусофир",
  do_not_find_order_message: "Фармоиш ёфт нашуд. Лутфан параметрҳоро тағйир диҳед",
  orders: "Фармоишҳо",
  contract_settings: "Танзимоти шартнома",
  main: "Асосӣ",
  users: "Корбарон",
  affiliated_companies: "Ширкатҳои фаръӣ",
  all_orders_label: "Ҳамаи фармоишҳо",
  book_done_label: "Брон шуд",
  pay_done_label: "Пардохт шуд",
  ticket_done_label: "Бароварда шуд",
  cancel_done_label: "Бекор шуд",
  wait_refund_label: "Интизори баргардонидан",
  refund_done_label: "Баргардонида шуд",
  partial_refund_done_label: "Қисман баргардонида шуд",
  void_done_label: "Бекор шуд",
  error_order_label: "Хатогии фармоиш",
  date_create_from: "Санаи эҷод аз",
  order_status_label: "Ҳолати фармоиш",
  search_title: "Насаб, локатор ё шаҳрро ворид кунед",
  date_create_to: "Санаи эҷод то",
  clear: "Тоза кардан",
  passenger_success_save: "Мусофир бомуваффақият сабт шуд",
  payment_with_dpt: "Пардохт аз баланс",
  payment_with_unt: 'Пардохт тавассути "Uniteller"',
  payment_with_spt: 'Пардохт тавассути "Корти миллӣ"',
  include_your_fees: "шомили ҳаққи шумо",
  before: "то",
  your_fees: "Ҳаққи шумо",
  month_one: "моҳ",
  months_more: "моҳ",
  months: "моҳ",
  all_passengers: "Ҳамаи мусофирон",
  passenger_success_remove: "Мусофир бомуваффақият ҳазф шуд",
  companies: "Ширкатҳо",
  no_companies: "Ширкатҳо нестанд",
  no_matches_found: "Мувофиқат ёфт нашуд",
  no_passengers: "Шумо ҳанӯз мусофирони сабтшуда надоред",
  enter_passenger_name: "Ном ё насаби мусофирро ворид кунед",
  add_passenger: "Илова кардани мусофир",
  your_partner_fees: "Ҳаққи шумо",
  type_of_fee: "Навъи ҳақ",
  value: "Арзиш",
  percent: "Фоиз",
  saved_successfully: "Бомуваффақият сабт шуд",
  error_saving: "Хатогӣ ҳангоми сабт",
  percent_from_total: "Фоиз аз ҳамагӣ",
  percent_from_fare: "Фоиз аз тариф",
  fix_flat: "Ҳаққи сохта",
  fix_flat_and_percent_from_total: "Ҳаққи сохта ва фоиз аз ҳамагӣ",
  fix_flat_and_percent_from_fare: "Ҳаққи сохта ва фоиз аз тариф",
  reset: "Аз нав оғоз кардан",
  invalid_value: "Арзиши нодуруст",
  no_orders_found: "Фармоишҳо ёфт нашуданд",
  personal_data: "Маълумоти шахсӣ",
  upload: "Бор кардан",
  your_logo: "Логотипи шумо",
  image_uploaded_successfully: "Тасвир бомуваффақият бор шуд",
  upload_logo: "Логотипро бор кунед",
  image_too_large: "Ҳаҷми тасвир хеле калон аст",
  image_resolution_too_high: "Тафкикнокии тасвир хеле баланд аст",
  image_resolution_too_small: "Тафкикнокии тасвир хеле хурд аст",
  rule_for_upload_img_1: "Формати тасвир .jpg, .jpeg, .png, .gif",
  rule_for_upload_img_2: "Тафкикнокӣ аз 300х100px то 2000x2000px",
  rule_for_upload_img_3: "Ҳаҷми файл на зиёда аз 4 МБ",
  amount: "Маблағ",
  rules_text_1: "Ба ибораҳои зерин дар бахш диққат диҳед",
  rules_text_2: "билет ба баргардонӣ тобеъ нест",
  rules_text_3: "билет дар сурати ҳозир нашудан ба парвоз ба баргардонӣ тобеъ нест",
  rules_text_4: "Қоидаҳои иваз дар бахш бо сарлавҳа тавсиф шудаанд",
  line: "Сатр",
  rules_text_5: "маънои онро дорад, ки тағйирот иҷозат дода намешаванд, аз ин рӯ тағйири санаҳои парвоз ғайриимкон аст",
  passenger_data: "Маълумоти мусофир",
  comment: "Шарҳ",
  contact_details: "Маълумоти тамос",
  contact_information: "Маълумоти тамос",
  remove: "Ҳазф кардан",
  add_document: "Илова кардани ҳуҷҷат",
  return_avia_rules: "Чӣ тавр иваз ё баргардонидан",
  booking_avia_rules: "Чӣ тавр фармоиш додан",
  created_at: "Санаи эҷод",
  updated_at: "Санаи навсозӣ",
  phone: "Телефон",
  create_user: "Эҷоди корбар",
  add: "Илова кардан",
  edit: "Таҳрир кардан",
  confirm: "Тасдиқ кардан",
  successfully_deleted: "Бомуваффақият ҳазф шуд",
  error_deleting: "Хатогӣ ҳангоми ҳазф",
  mess_want_to_delete: "Шумо воқеан мехоҳед ҳазф кунед",
  record_one: "сабт",
  record_more: "сабт",
  record_many: "сабт",
  user_type: "Навъи муштарӣ",
  admin_role: "Маъмур",
  manager_role: "Менеҷер",
  user_agent_role: "Агент",
  user_role: "Корбар",
  security_guarantees_unitaller: "Кафолатҳои бехатарӣ",
  activation_title: "Фаъолсозии корбар",
  confirmation_activation_password: "Тасдиқи парол",
  enter_activation_password: "Паролро ворид кунед",
  activation: "Фаъолсозӣ",
  login: "Вуруд",
  error_activating_user: "Хатогӣ ҳангоми фаъолсозии корбар",
  error: "Хатогӣ",
  to_login_form: "Ба саҳифаи вуруд",
  expired_date: "Муҳлат анҷом ёфт",
  refund_button_title: "Баргардонидан",
  itinerary_receipt: "Қабули роҳхат",
  action: "Амал",
  to_pay: "Пардохт кардан",
  order_cancel_error_mess: "Хатогӣ ҳангоми бекоркунии фармоиш",
  order_cancel_successfully_mess: "Бомуваффақият бекор шуд",
  partner: "Шарик",
  inn: "Рақами мушаххаси андоз",
  kpp: "Коди сабабӣ",
  logo: "Логотип",
  create_partner: "Эҷоди шарик",
  status: "Ҳолат",
  add_your_details: "Маълумоти худро илова кунед",
  return_request_created: "Ариза барои баргардонидан эҷод шуд",
  error_creating_refund_request: "Хатогӣ ҳангоми эҷоди ариза барои баргардонидан",
  activation_status: "Ҳолати фаъолсозӣ",
  placeholder_date_picker: "рр.мм.сссс",
  created_company_successfully: "Ширкат эҷод шуд",
  error_created: "Хатогӣ ҳангоми эҷод",
  deposit_statement: "Дархости баровардан тавассути депозит",
  transactions: "Транзаксияҳо",
  weight_unit: "кг",
  credit_funds: "Маблағҳои қарзӣ",
  overrun: "Зиёдравӣ",
  transaction_time: "Вақти транзаксия",
  before_balance_change: "Пеш аз тағйири баланс",
  allow_balance_payment: "Иҷозати пардохт аз баланс",
  approved_balance_request_successfully: "Ариза барои баровардан аз баланс тасдиқ шуд",
  error_approved_balance_request_successfully: "Хатогӣ ҳангоми тасдиқи ариза барои баровардан аз баланс",
  balance_payment_request: "Ариза барои баровардан аз баланс",
  balance_payment_approved: "Ариза барои баровардан аз баланс тасдиқ шуд",
  payment_with_uzc: 'Пардохт тавассути "Uzcard"',
  allow_payment: "Иҷозати пардохт",
  statement_request: "Дархост барои баровардан",
  client: "Муштарӣ",
  was_changed_to: "тағйир ёфт ба",
  deposit_statement_request_created: "Ариза барои баровардан аз депозит эҷод шуд",
  registration: "Бақайдгирӣ",
  error_creating_deposit_statement_request: "Хатогӣ ҳангоми эҷоди ариза барои баровардан аз депозит",
  deposit_statement_request_confirmed: "Ариза барои баровардан аз депозит тасдиқ шуд",
  error_confirming_deposit_statement_request: "Хатогӣ ҳангоми тасдиқи ариза барои баровардан аз депозит",
  fare: "Тариф",
  fees: "Ҳаққҳо",
  partner_fees: "Ҳаққҳои шарик",
  taxes: "Андозҳо",
  ticket: "Билет",
  pay_for_the_order: "Пардохти фармоиш",
  operating_company: "Ширкати оператор",
  download_charter_certificate: "Боркунии шаҳодатномаи чартерӣ",
  certificate_issued: "Шаҳодатномаи чартерӣ бароварда шуд",
  charter: "Чартер",
  service: "Хизмат",
  income: "Даромад",
  spending: "Харҷот",
  remainder: "Боқимонда",
  description: "Тавсиф",
  contract: "Шартнома",
  column_selection: "Интихоби сутун",
  your_commission: "Комиссияи шумо",
  no_result: "Натиҷа нест",
  date: "Сана",
  movement_balance: "Ҳаракати маблағ дар баланс",
  current_balance_sheet: "Ҳолати ҷории баланс",
  indebtedness: "Қарздорӣ",
  date_from_d: "Сана аз",
  date_to_d: "Сана то",
  order_num: "Рақами фармоиш",
  order_details: "Тафсилоти фармоиш",
  flight_info: "Маълумот дар бораи парвоз",
  price: "Нарх",
  status: "Ҳолат",
  orders_subtitle: "Бронҳои худро дида тавонед ва идора кунед",
  successful: "Муваффақ",
  cancelled: "Бекор шуда",
  timeout: "Мувофиқи таймлимит",
  success: "Муваффақ",
  order_cancelled_by_customer: "Фармоиш аз ҷониби муштарӣ бекор шуд",
  order_cancelled_by_time_limit: "Фармоиш мувофиқи таймлимит бекор шуд",
  successful_payment_tickets_issued: "Пардохти муваффақ, билетҳо бароварда шуданд",
  status_refund: "Баргардонидан",
  status_exchange: "Иваз",
  status_void: "Бекор шуд",
  status_error: "Хатогӣ",
  status_pending: "Интизорӣ",
  status_processing: "Дар ҷараён",
  status_booked: "Брон шуд",
  booking_num: "Рақами брон",
  search_operations: "Ҷустуҷӯи амалиётҳо",
  upload_report: "Бор кардани гузориш",
  payment_with_vsl: 'Пардохт тавассути "Корти миллӣ"',
  popular_destinations: "Самтҳои маъмул",
  more_options: "Варианти бештар",
  hide_list: "Пинҳон кардани рӯйхат",
  straight: "Бевосита",
  with_transfer: "Бо гузариш",
  finances: "Молия",
  contacts: "Тамосҳо",
  all_classes: "Ҳамаи синфҳо",
  difficult_routes: "Сохтани маршрути мураккаб",
  search_history: "Таърихи ҷустуҷӯ",
  go_to_page: "Гузаштан",
  find_tickets: "ёфтани билетҳо",
  tours_discount: "Турҳои судманд ва тахфифҳо",
  last_news: "Охирин хабарҳо",
  more_details: "Муфассалтар",
  about_company: "Дар бораи ширкат",
  wannatalk: "Мехоҳед гуфтугӯ кунед?",
  customer_rew: "Шарҳи муштариён",
  my_profile: "Профили ман",
  contact_us: "Бо мо тамос гиред",
  last_name: "Насаб",
  first_name: "Ном",
  father_name: "Номи падар",
  enter_login: "Логини худро ворид кунед",
  enter_name: "Номи худро ворид кунед",
  enter_surname: "Насаби худро ворид кунед",
  enter_fathname: "Номи падари худро ворид кунед",
  aeroflot: "Аэрофлот",
  uz_airways: "Ҳавопаймоҳои Ӯзбекистон",
  turkish: "Ҳавопаймоҳои Туркия",
  ural: "Ҳавопаймоҳои Урал",
  korea: "Ҳавопаймоҳои Корея",
  qanot: "Қанот Шарқ",
  belavia: "Белавиа",
  apgAS: "APG Air Solution",
  pobeda: "Победа",
  airastana: "Air Astana",
  flyaristan: "Fly Aristan",
  s7: "Ҳавопаймоҳои Сибир",
  enter_password: "Паролро ворид кунед",
  flight_search: "Ҷустуҷӯи билетҳои ҳавоӣ",
  buy_air_tickets: "Билетҳоро бе берун рафтан аз хона харед",
  log_in: "Ворид шудан",
  welcome_back: "Боз омадед!",
  return_to_simple_route: "Бозгашт ба маршрути оддӣ",
  delete: "Ҳазф кардан",
  max_num_flights: "Шумо миқдори максималии парвозҳоро илова кардед",
  select_dep_date: "Санаи парвозро интихоб кунед",
  select_return_date: "Санаи баргаштро интихоб кунед",
  select_class: " Синфро интихоб кунед",
  login_as_user: "Барои дастрасӣ ба ҳисоб маълумоти худро ворид кунед",
  enter_recieved_code: "Коди гирифташударо ворид кунед",
  come_up_your_pass: "Пароли худро эҷод кунед",
  enter_valid_mail: "Email-и дурустро ворид кунед",
  must_field_characters: "Майдон бояд камаш 6 аломат дошта бошад",
  register_to_save_data: "Барои захира кардани маълумот бақайдгирӣ кунед",
  ins_main_label: " Ширхӯр",
  ins_second_label: " то 2 сол (бо ҷой)",
  newsletter_subscription: "Обуна шудан ба хабарнома",
  newsletter_subscription_text: "Обуна шавед, то аз ҳамаи хабарҳо ва пешниҳодҳои судманд огоҳ бошед!",
  subscribe: "Обуна шудан",
  successfully_subscribed: "Шумо бомуваффақият обуна шудед!",
  subscription_error: "Хатогӣ ҳангоми обуна, баъдтар кӯшиш кунед!",
  all_news: "Ҳамаи хабарҳо",
  tel: "Тел",
  enter_email: "Email-и худро ворид кунед",
  menu: "Меню",
  settings: " Танзимот",
  deposit_method: "Усули пурронро интихоб кунед",
  recharging_amount: "Маблағи пуррон",
  recharge: " Пуррон кардан",
  recharging_balance: "Пурронии баланс",
  done: " Тайёр",
  not_found_content: " Ёфт нашуд",
  not_found_content_text: " Мутаассифона, ин мундариҷа бо забони интихобшуда дастрас нест",
  airport_code: "Коди фурудгоҳ",
  from_city: "Аз ш.",
  to_city: "Ба шаҳр",
  weekdays: "Рӯзҳои ҳафта",
  weekends: "Рӯзҳои истироҳат",
  weekends1: "1 ва 2 - Январ",
  weekends2: "8 - Март",
  weekends3: "аз 21 то 24 - Март",
  weekends4: "9 - Май",
  weekends5: "27 - Июн",
  weekends6: "9 - Сентябр",
  weekends7: "6 - Ноябр",
  weekends8: "Инчунин дар давоми ҷашнҳои Ид",
  airline: "Ширкати ҳавопаймоӣ",
  min_number: "Маблағ бояд зиёдтар аз",
  only_numbers: " Танҳо рақамҳо",
  must_register: " Барои харидани билетҳо дар сайти мо, шумо бояд ворид шуда бошед",
  daily: "Ҳаррӯза",
  fly_tagline: "Бо мо парвоз кардан осон аст",
  sorting: "Мураттабсозӣ",
  i_read_fares: "Ман шинос шудам бо",
  i_accept_fares: "ва бо онҳо розӣ ҳастам",
  prices_table: "Ҷадвали нархҳо",
  continue: "Идома додан",
  reset_error_title: "Хатогӣ",
  reset_error_content: "Бубахшед, ҳангоми иҷрои дархост хатогӣ рух дод",
  reset_success_title: "Шумо бомуваффақият пароли худро иваз кардед!",
  page_my_transactions: "Ҳисобот дар бораи пардохтҳои анҷомшуда",
  reset_success_content: 'Лутфан, тугмаи "Ворид шудан"-ро пахш кунед, то бо пароли нав ворид шавед',
  forgot_success_title: "Муваффақ!",
  forgot_success_content: "Истинод барои барқарорсозии парол ба почтаи шумо фиристода шуд",
  forgot_error_title: "Хатогӣ",
  forgot_error_content: "Бубахшед, вале шумо E-Mail-и нодуруст ворид кардед",
  password_confirm: "Тасдиқи парол",
  password_confirm_error: "Паролҳо мувофиқат намекунанд",
  enter_password_confirm: "Паролро тасдиқ кунед",
  reset_password: "Барқарорсозии пароли корбар",
  mail_sent: "Мактуб фиристода шуд!",
  enter_new_password: "Пароли навро ворид кунед",
  forgot_password: "Паролро фаромӯш кардед?",
  forgot_password_summary: "Барои барқарорсозии парол почтаи электронии худро ворид кунед",
  password_recovery_text:
    "Суроғаи почтаи электронии дар сайти мо бақайдгирифташударо ворид кунед. Мо ба шумо истиноди барқарорсозиро мефиристем",
  password_recovery_confirm_text: "Мо ба шумо ба почта мактубе бо истиноди барқарорсозӣ фиристодем",
  popup_event_text: "Пас аз бақайдгирӣ бонуси 100 сомонӣ ба баланси ҳисоби шахсии худ гиред",
  popup_description: "Дар сайт бақайдгирӣ кунед ва билетҳоро онлайн, бе берун рафтан аз хона харед!",
  payment_milly: 'Пардохт тавассути "Корти миллӣ"',
  from_airport: "Аз фурудгоҳ",
  not_enough_balance: "Барои пардохт маблағ кофӣ нест",
  questions_and_answers: "Саволҳо ва ҷавобҳо",
  payment_methods: "Усулҳои пардохт",
  our_partners: "Шарикони мо",
  confirm_actions: "Амали худро дар сайт тасдиқ кунед",
  payer_contacts: "Тамосҳои пардохткунанда",
  buyer_email: "Email-и харидор",
  enter_buyer_email: "Email-и харидорро ворид кунед",
  locator_order_number_or_booking_number: "Локатор, рақами фармоиш ё рақами брон",
  enter_locator_order_number_or_booking_number: "Локатор, рақами фармоиш ё рақами бронро ворид кунед",
  activate: "Фаъол кардан",
  register: "Бақайдгирӣ кунед",
  deals: "Аксияҳо",
  pre_cashback: "Билетҳои ҳавоиро харед ва кэшбэки сохта гиред",
  partners: "Ширкатҳои ҳавопаймоии шарик",
  scoreborad: "Таблои онлайнии фурудгоҳҳо",
  cashback0: "Шартномаи бевосита. Нархҳо аз ширкатҳои ҳавопаймоӣ",
  cashback_from:
    "Кэшбэк аз ширкатҳои ҳавопаймоии шарикони лоиҳа ба парвозҳое татбиқ мешавад, ки аз фурудгоҳҳои Тоҷикистон мебошанд. Кэшбэк аз тариф ҳисоб карда мешавад.",
  cashback_from_in:
    "Кэшбэк аз ширкатҳои ҳавопаймоии шарикони лоиҳа ба парвозҳое татбиқ мешавад, ки аз/ба фурудгоҳҳои Тоҷикистон мебошанд. Кэшбэк аз тариф ҳисоб карда мешавад.",
  tarif: "аз тариф",
  post_cashback: "ба баланси ҳисоби шахсӣ",
  cashback_message: "Барои гирифтани кэшбэк, шумо бояд дар сайт бақайдгирӣ кунед ва билетҳоро тавассути хидмати мо харед.",
  cashback_message_auth: "Ба шумо пешниҳодҳои зерини кэшбэк дастрас аст:",
  page_home: "Харидани онлайнии билетҳо, бе муроҷиат ба касса",
  page_faq: "Ҷавоб ба саволҳои маъмул",
  page_login: "Ворид шудан ба ҳисоби шахсӣ",
  page_registration: "Бақайдгирӣ кунед ва билетҳо харед",
  page_results: "Натиҷаҳо барои маршрути шумо",
  page_booking: "Бронкунии билети муайян",
  page_order: "Маълумот дар бораи фармоиши анҷомшуда",
  page_orders_list: "Маълумот дар бораи фармоишҳои анҷомшуда",
  page_my_profile: "Маълумоти шахсӣ",
  page_add_balance: "Пурронии баланси ҳисоби шахсӣ",
  page_popular_destinations: "Ҷадвали парвозҳои маъмул",
  page_news: "Хабарҳои маъмули ҳавопаймоӣ ва Fly TJ",
  page_forgot_password: "Харидани онлайнии билетҳо бе берун рафтан аз хона!",
  page_reset_password: "Харидани онлайнии билетҳо бе берун рафтан аз хона!",
  useful_info: "Маълумоти муфид",
  copy_link: "Нусхабардории истинод",
  copy_order_link_text: "Истинодро нусхабардорӣ кунед, то дастрасӣ ба ин фармоишро мубодила кунед",
  link_copied_to_clipboard: "Истинод ба буфер нусхабардорӣ шуд",
  unsubscribe_success: "Шумо бомуваффақият аз обуна ба хабарҳо хориҷ шудед!",
  unsubscribe_error: "Ҳангоми коркард хатогӣ рух дод",
  activation_code_send_to_email: "Коди тасдиқ ба почтаи шумо фиристода мешавад",
  choose_gender: "Ҷинсро интихоб кунед",
  old_information: "Маълумот кӯҳна шудааст!",
  refresh: "Нав кардан",
  refresh_page: "Нархҳои билетҳои ҳавоӣ якчанд маротиба дар рӯз навсозӣ мешаванд. Саҳифаро барои санҷиши нархҳои ҷорӣ нав кунед.",
  will_take_2_minutes: "Ин метавонад каме вақт гирад",
  error_additional_options_text:
    "Ҳангоми фаъол кардани имконоти иловагӣ барои бронкунӣ хатогӣ рух дод. Бе имконоти иловагӣ давом диҳем?",
  edit_personal_data: "маълумоти шахсии худро тағйир диҳед",
  minimum_amount: "Маблағи минималӣ",
  additional_options: "Хидматҳои иловагӣ",
  additional_options_not_found: "Хидматҳои иловагӣ ёфт нашуданд!",
  profile_changed: "Профил бомуваффақият тағйир ёфт",
  welcome: "Хуш омадед",
  register_on_somon_air: "Бақайдгирӣ дар Somon Air",
  min_6_symbol: "Камаш 6 аломат",
  your_id: "ID-и шумо",
  cheapest_without_baggage: "Арзонтарин бе бор",
  cheapest_with_baggage: "Арзонтарин бо бор",
  most_convenient_transfes: "Гузариши қулайтарин",
  fly_ru_tagline: "Ҷаҳонро эҳсос кунед!",
  fly_ru_subtagline: "Дастрасии шумо ба ҳамаи ширкатҳои ҳавопаймоии ҷаҳон",
  fly_ru_round_the_clock: "Шабонарӯзӣ",
  refund_order: "Ариза барои баргардонидани маблағ",
  refund_reason: "Сабаби баргардонидан",
  order_payment_method: "Усули пардохти фармоиш",
  payer_user_id: "ID-и корбари пардохткунанда",
  four_last_digits_of_card: "4 рақами охирини корти пардохт",
  user_id: "ID-и корбар",
  buyer_phone: "Телефони харидор",
  requisite_of_account_to_return: "Реквизитҳои ҳисоб барои баргардонидани маблағ",
  requisite_of_account: "Реквизитҳои ҳисоб",
  passenger_name_and_surname: "Насаб ва номи мусофир",
  passport_serial_and_number: "Серия ва рақами шиносномa",
  passport_copy: "Нусхаи шиносномa",
  send: "Фиристодан",
  payment_from_client_balance: "Пардохт аз баланси муштарӣ",
  payment_from_card: "Пардохт бо ёрии корт",
  vasl_tagline: "Қулайӣ дар афзалият!",
  technical_support: "Дастгирии техникӣ",
  success_refund_order_request: "Ариза барои баргардонидани маблағ бомуваффақият фиристода шуд!",
  error_refund_order_request: "Хатогӣ ҳангоми фиристодани ариза барои баргардонидани маблағ!",
  find_options: "ёфтани билетҳо",
  buy_tickets_to_all_destinations: "ва билетҳоро ба ҳамаи самтҳо харед!",
  filters: "Филтрҳо",
  operation_type: "Навъи амалиёт",
  all_operations: "Ҳамаи амалиётҳо",
  balance_operation: "Амалиёт бо баланс",
  order_payment: "Пардохти фармоиш",
  apply_filters: "Татбиқи филтрҳо",
  export: "Содирот",
  view_manage_transactions: "Дидан ва идораи таърихи транзаксияҳо",
  no_transactions: "Шумо транзаксияҳо надоред!",
  showing: "Нишон дода шуд",
  of_total: "аз",
  transactions_count: "транзаксияҳо",
  previous: "Қаблӣ",
  next: "Навбатӣ",
  date_and_time: "Сана ва вақт",
  merchant: "Мерчант",
  type: "Навъ",
  search_by_order: "Ҷустуҷӯ мувофиқи фармоиш...",
  recharge_balance: "Пурронии баланс",
  add_funds_securely: "Ҳисоби худро бехатар пуррон кунед",
  select_payment_method: "Усули пардохтро интихоб кунед",
  quick_amounts: "Маблағҳои тез",
  important_information: "Маълумоти муҳим",
  minimum_recharge: "Пурронии минималӣ",
  maximum_recharge: "Пурронии максималӣ",
  processing_time: "Вақти коркард",
  instant: "Фаврӣ",
  no_additional_fees: "Бе комиссияҳои иловагӣ",
  recent_recharges: "Пурронҳои охирин",
  no_recent_recharges: "Пурронҳои охирин нестанд",
  max_number: "Маблағ бояд камтар аз",
  night_flight: "Гузариши шабона",
  change_airport: "Иваз кардани фурудгоҳ",
  and: "ва",
  from: "аз",
  refund_order_success: "Аризаи баргардонидан бомуваффақият фиристода шуд",
  refund_order_error: "Хатогӣ ҳангоми фиристодани аризаи баргардонидан",
  buy_tour: "Харидани тур",
  payment_alert: "Корбари гиромӣ, фармоиши шумо пардохт шуд. Вақти баровардан 1 дақиқа.",
  customer_office_address: "Суроғаи дафтари корӣ барои муштариён",
  inner_document: "Ҳуҷҷати дохилӣ",
  inner_links: "Тавсия мекунем хондан:",
  document_copy: " Нусхаи ҳуҷҷат",
  maximum_amount: "Маблағи максималӣ",
  search_limits_exceeded:
    "Корбари гиромӣ, шумо миқдори ҷустуҷӯҳоро зиёд кардед, лутфан барои давом додани кор воридшавӣ/бақайдгирӣ гузаред",
  flight_without_seats: "Мутаассифона, ҷойҳо дар ин парвоз тамом шудаанд",
  document_type: "Навъи ҳуҷҷат",
  document_number: "Рақами ҳуҷҷат",
  expiration_date: "Муҳлати эътибор",
  any_cabin: "Ҳама синф",
  my: "Ман",
  site: "Сайт",
  show_more: "Бештар нишон додан",
  route: "Маршрут",
  pay_before: "Пардохт то",
  price_expired_title: "Нархҳо кӯҳна шудаанд",
  price_expired_text: "Нархҳо метавонанд дар давоми вақте, ки шумо набудед, кӯҳна шуда бошанд, саҳифаро барои дидани нархҳои охирин нав кунед.",
  price_expired_button: "Навсозии саҳифа",
  price_changed_title: "Нарх тағйир ёфт",
  price_changed_text_up: "Ҳангоми расмикунонии фармоиш ширкати ҳавопаймоӣ нархи парвозро тағйир дод. Нархи нав аз пештара баландтар аст.",
  price_changed_text_down: "Ҳангоми расмикунонии фармоиш ширкати ҳавопаймоӣ нархи парвозро тағйир дод. Нархи нав аз пештара пасттар аст.",
  price_changed_old: "Нархи пешина",
  price_changed_new: "Нархи нав",
  price_changed_question: "Бо нархи нав идома медиҳед?",
  price_changed_agree: "Розӣ ҳастам, идома",
  price_changed_disagree: "Розӣ нестам, ба ҷустуҷӯ баргаштан",
  price_changed_moved_again: "Нарх боз тағйир ёфт. Маблағи навро тафтиш кунед ва дубора тасдиқ кунед.",
  price_changed_update_error: "Нархро навсозӣ карда нашуд. Боз кӯшиш кунед.",
  price_changed_loading: "Нарх навсозӣ мешавад…",
  price_changed_prebook_text_up: "Аз лаҳзаи ҷустуҷӯ ширкати ҳавопаймоӣ нархи ин парвозро тағйир дод. Нархи нав аз пештара баландтар аст.",
  price_changed_prebook_text_down: "Аз лаҳзаи ҷустуҷӯ ширкати ҳавопаймоӣ нархи ин парвозро тағйир дод. Нархи нав аз пештара пасттар аст.",
  price_changed_prebook_question: "Брониро бо нархи нав идома медиҳед?",
  price_changed_prebook_disagree: "Розӣ нестам, ҷустуҷӯро нав кунед",
  prebook_flight_unavailable: "Парвоз дигар дастрас нест: ҷой ё тарофаи интихобшуда намондааст. Ҷустуҷӯро аз нав иҷро кунед.",
  prebook_error_title: "Хатои боркунии парвоз",
  prebook_error_search_again: "Ҷустуҷӯи нав",
  get_visa_title: "Хабар медиҳем, ки оё визa лозим аст",
  get_visa_subtitle: "Нишон диҳед, ки шумо куҷо меравед",
  get_visa_result_title: "Омодаед, ки дар бораи талаботи виза донед?",
  get_visa_result_desc:
    "Шаҳрвандӣ ва кишвари таъиноти худро интихоб кунед, то маълумоти ҷории лозимии виза гиред",
  select_citizenship: "Шаҳрвандии худро интихоб кунед",
  select_placeholder_citizenship: "Шаҳрвандии шумо",
  select_destination: "Кишвари таъиноти худро интихоб кунед",
  select_placeholder_destination: "Кишвари таъинот",
  get_visa_loading_message: "Талаботи визaро санҷида истодаем...",
  in_house: "Барои парвозҳои дохилӣ виза лозим нест",
  no_country: "Кишвар ёфт нашуд",
  no_data: "Маълумот нест.",
  check_console_website: "Лутфан, сайти консулгариро санҷед.",
  no_visa: "Виза лозим нест",
  no_visa_14: "Виза то 14 рӯз лозим нест",
  no_visa_15: "Виза то 15 рӯз лозим нест",
  no_visa_21: "Виза то 21 рӯз лозим нест",
  no_visa_28: "Виза то 28 рӯз лозим нест",
  no_visa_30: "Виза то 30 рӯз лозим нест",
  no_visa_60: "Виза то 60 рӯз лозим нест",
  no_visa_90: "Виза то 90 рӯз лозим нест",
  no_visa_180: "Виза то 180 рӯз лозим нест",
  no_visa_360: "Виза то 360 рӯз лозим нест",
  no_restrictions: "Вуруд бе маҳдудият",
  visa_on_arrival: "Виза ҳангоми фуруд омадан",
  visa_on_arrival_desc: "Дар назорати паспортӣ расмӣ карда мешавад",
  e_visa: "Визаи электронӣ",
  visa_required: "Виза лозим аст",
  check_council: "Шартҳоро дар сайти консулгарӣ санҷед",
  to_pay_title: "Ҳамагӣ барои пардохт",
  flight_selection: "Интихоби парвоз",
  passenger_details: "Маълумоти мусофир",
  base_fare: "Тарифи асосӣ",
  taxes_and_fees: "Андозҳо ва ҳаққҳо",
  includes_service_charges: "Шомили ҳаққҳои хизматрасонӣ",
  allowed: "Иҷозат дода шудааст",
  non_refundable: "Ба баргардонидан тобеъ нест",
  non_exchangeable: "Ба иваз тобеъ нест",
  contact_operator: "Бо оператор тамос гиред",
  direct_flight: "Парвози бевосита",
  processing: "Дар ҳоли коркард",
  copyright: "© 2026 Skyrix.dev. Ҳамаи ҳуқуқҳо ҳифз шудаанд.",
  services_in_development_title: "Саҳифа дар ҳоли таҳия аст",
  services_in_development_description: "Мо фаъолона дар ин бахш кор мекунем. Ба наздикӣ дар ин ҷо хизматрасониҳо ва имконоти нав пайдо мешаванд. Навигариҳоро пайгирӣ кунед!",
  not_found_title: "Саҳифа ёфт нашуд",
  not_found_description: "Чунин менамояд, ки ин парвоз бекор карда шудааст. Суроғаро тафтиш кунед ё ба саҳифаи асосӣ баргардед, то самти навро пайдо кунед!",
  go_to_home: "Ба саҳифаи асосӣ",
  login_exist: "Корбар бо ин E-mail аллакай мавҷуд аст!",
  unable_to_send_email: "Фиристодани мактуб ғайриимкон буд. Баъдтар кӯшиш кунед.",
  baggage_not_included: "Бағоҷ дохил нест",
  hand_luggage_not_included: "Бағоҷи дастӣ дохил нест",
  clarify_weight_contact_operator: "Барои равшан кардани вазни дақиқи бағоҷи дастӣ ё бағоҷ, бо оператор тамос гиред",
  registration_error: "Хатогӣ ҳангоми бақайдгирӣ. Баъдтар кӯшиш кунед.",
  incorrect_client_login: "Логин ё парол нодуруст аст",
  not_exist_or_not_active_user: "Корбар ёфт нашуд ё фаъол нашудааст",
  password_reset_error: "Хатогӣ ҳангоми барқарорсозии парол. Баъдтар кӯшиш кунед.",
  new_password_saved: "Пароли нав бомуваффақият ҳифз шуд!",
  can_login_with_new_password: "Шумо метавонед бо пароли нав ворид шавед",

  // About page
  about_hero_title_1: "Дар бораи ширкат",
  about_hero_subtitle: "МЧЖ «С-Сервис» — намояндагии МЧЖ «Ширкати ҳавопаймоии Сомон Эйр» дар шаҳри Москва ва вилояти Москва.",
  about_stat_founded: "Соли таъсис",
  about_stat_customers: "Муштариёни хушнуд",
  about_stat_airlines: "Ширкатҳои ҳавопаймоии шарик",
  about_stat_support: "Дастгирии муштариён",
  about_mission_title: "Вазифаҳо ва функсияҳои мо",
  about_mission_text_1: "Вазифаҳо ва функсияҳои мо — намояндагии ширкатҳои ҳавопаймоӣ дар бозори авиатсионӣ, ташкили нақлиёти мусофирон ва борҳо аз фурудгоҳи «Домодедово».",
  about_mission_text_2: "«С-Сервис» аз соли 2011 дар бозори авиатсионӣ фаъолият мекунад.",
  about_history_title: "Дар бораи мо",
  about_history_text_1: "Намояндагии МЧЖ «Ширкати ҳавопаймоии Сомон Эйр» ва АО «Ширкати ҳавопаймоии Тоҷик Эйр» дар шаҳри Москва ва вилояти Москва бо мақсадҳои зерин таъсис ёфта, фаъолият мекунад:",
  about_history_text_2: "— ҳимояи манфиатҳои ширкатҳои ҳавопаймоӣ дар минтақаи Москва.",
  about_history_text_3: "— намояндагии ширкатҳои ҳавопаймоӣ дар фурудгоҳи «Домодедово», аз ҷумла ҳамчун агенти фурӯши нақлиёти мусофирон.",
  about_values_title: "Арзишҳои мо",
  about_value_1_title: "Нархҳои беҳтарин",
  about_value_1_text: "Мо пешниҳодҳои ширкатҳои пешбари ҳавопаймоиро ҷамъ меоварем, то шумо ҳамеша муносибтарин тарифҳоро пайдо кунед.",
  about_value_2_title: "Амнияти маълумот",
  about_value_2_text: "Маълумоти шумо ва пардохтҳо пурра ҳифз шудаанд. Мо танҳо бо системаҳои пардохти тасдиқшуда кор мекунем.",
  about_value_3_title: "Дастгирии 24/7",
  about_value_3_text: "Гурӯҳи мо дар ҳар марҳала — аз интихоби парвоз то гирифтани картаи нишаст — омода аст ба шумо кӯмак расонад.",
  about_cta_title: "Барои парвоз омодаед?",
  about_cta_text: "Ҳозир беҳтарин чиптаҳои ҳавопайморо пайдо кунед ва ба сафари орзуии худ раҳсипор шавед.",
  about_cta_button: "Чиптаҳо пайдо кунед",

  why_us_title: "Чаро аз мо мехаранд",
  why_us_item_1: "Агенти расмии Somon Air дар Россия",
  why_us_item_2: "Дастгирии мусофирон 24/7",
  why_us_item_3: "Пардохт бо корти бонкии Россия",
  why_us_item_4: "Чиптаи электронӣ дар 1 дақиқа",
  why_us_button: "Бо дастгирӣ тамос гиред",

  trust_title: "Ба мо эътимод доранд",
  trust_stat_tickets: "чиптаи фурӯхташуда",
  trust_stat_years_unit: "сол",
  trust_stat_years: "дар бозори авиатсионӣ",
  trust_stat_support: "дастгирии мусофирон",
  trust_button: "Чиптаро харед",
  copy_text: "Матнро нусхабардорӣ кунед",
  text_copied: "Нусхабардорӣ шуд",
  // заявка на возврат
  refund_request_subtitle: "Шаклро пур кунед ва аризаи баргардонидани маблағро замима кунед. Мо фармоишро тафтиш карда, бо шумо тамос мегирем.",
  order_number_label: "Рақами фармоиш",
  enter_order_number: "Рақами фармоишро ворид кунед",
  enter_refund_reason: "Сабаби баргардониданро нависед",
  refund_requisites_hint: "Масалан: рақами корт ё ҳисоб, бонк, гиранда",
  refund_document: "Ариза барои баргардонидан / нусхаи ҳуҷҷат",
  refund_document_hint: "PDF, DOC, DOCX, JPG ё PNG, то 10 МБ",
  choose_file: "Интихоби файл",
  file_not_chosen: "Файл интихоб нашудааст",
  file_required: "Файлро замима кунед",
  file_too_large: "Ҳаҷми файл аз 64 МБ зиёд аст",
  file_wrong_format: "Формати файл дастгирӣ намешавад",
  refund_request_sent_text: "Аризаи шумо қабул шуд. Ҳолати фармоиш ба «Аризаи баргардонидан» тағйир меёбад, пас аз тафтиш бо шумо тамос мегиранд.",
  refund_status_not_suitable: "Барои ин фармоиш аризаи баргардонидан дастнорас аст: чиптаҳо ҳанӯз дода нашудаанд ё баргардонидан аллакай ба расмият дароварда шудааст.",
  refund_passengers_label: "Мусофирон барои баргардонидан",
  refund_passenger_refunded: "Баргардонида шуд",
  refund_passenger_in_request: "Ариза аллакай фиристода шудааст",
  refund_passengers_hint: "Мусофиронеро, ки баргардонидан лозим аст, қайд кунед. Кӯдаки ширхор бо калонсол баргардонида мешавад.",
  refund_select_passenger_required: "Ақаллан як мусофирро интихоб кунед",
  refund_infant_without_adult: "Кӯдаки ширхор бе калонсол дар фармоиш монда наметавонад: онро бо калонсол баргардонед.",
  refund_passengers_invalid: "Мусофирони интихобшуда аллакай баргардонида шудаанд ё ба фармоиш тааллуқ надоранд.",
  to_orders: "Ба фармоишҳои ман",
  request_refund: "Аризаи баргардонидан",
  optional_field: "ихтиёрӣ",
  payment_commission_title: "Маблағи пардохт тағйир ёфт",
  payment_commission_text: "Ҳангоми пардохт тавассути «{{method}}» системаи пардохт комиссия мегирад — он ба маблағи фармоиш илова шуд.",
  payment_commission_order_amount: "Арзиши фармоиш",
  payment_commission_fee: "Комиссияи системаи пардохт",
  payment_commission_total: "Ба пардохт",
  payment_commission_hint: "Шумо метавонед усули дигари пардохтро бо комиссияи камтар ё бе комиссия интихоб кунед.",
  payment_commission_ok: "Фаҳмо",
  payment_commission_choose_other: "Усули дигарро интихоб кунед",
  payment_commission_to_pay: "Ба пардохт бо комиссия",
  // дополнительные услуги к заказу (eSIM, багаж и т.п.)
  additional_options_hint: "Пеш аз пардохт ба фармоиш илова кардан мумкин аст. Хизматҳо пас аз пардохт ба расмият дароварда мешаванд, ҳуҷҷатҳо якҷоя бо чипта меоянд.",
  add_option: "Илова кардан",
  remove_option: "Хориҷ кардан",
  price_on_request: "Нарх бо дархост",
  additional_options_error: "Хизматҳои иловагӣ тағйир дода нашуданд, боз кӯшиш кунед",
  additional_options_total: "Хизматҳои иловагӣ",
  additional_options_price_changed: "Нархи хизматрасониҳои иловагӣ тағйир ёфт. Маблағи нави фармоишро санҷед ва аз нав пардохт кунед.",
  seats_choose: "Интихоби ҷойҳо",
  seats_hide_map: "Пинҳон кардани нақша",
  seats_not_selected: "Ҷойҳо интихоб нашудаанд",
  meal_current_replace: "Ҳозир: {{meal}} — интихоби дигар онро иваз мекунад",
  seat_not_selected: "ҷой интихоб нашудааст",
  seat_free_of_charge: "Ройгон",
  seat_occupied: "Банд",
  seat_exit_row: "баромадгоҳи фавқулодда",
  passenger: "Мусофир",
  payment_checking_notice: "Пардохти шуморо месанҷем. Агар аллакай пардохт карда бошед, такроран пардохт накунед — ҳолати фармоиш худкор нав мешавад.",
};

export default tj;
